import { Injectable } from '@angular/core';
import { FileUploadType, getUploadFileRouteName } from '@core/models/file.model';
import { BaseService } from '@core/services/base/base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService extends BaseService {
  public uploadProgress = new BehaviorSubject(0);

  constructor(private errorHandlerService: ErrorHandlerService, private authService: AuthService) {
    super();
  }

  upload(file: File, inputName: FileUploadType, filter?: { fileType: FileUploadType }) {
    let url = getUploadFileRouteName(inputName);
    url += '?' + this.getParamsFromFilter(filter);

    return new Observable<string>(observer => {
      const request = new XMLHttpRequest();
      const formData = new FormData();
      request.open('POST', url, true);

      formData.append('file', file);
      const token = this.authService.getToken();
      request.setRequestHeader('Authorization', 'Bearer ' + token.access_token);

      request.onreadystatechange = () => {
        this.updateFileUploadProgress(request.readyState);

        if (request.readyState === 4) {
          if (request.status === 200) {
            if (request.responseText === file.name) {
              observer.next(request.responseText);
            }
          } else {
            this.errorHandlerService.showErrorMessage(
              [],
              request.status,
              'Impossible de télécharger le fichier. Veuillez essayer plus tard.'
            );
            observer.error('Impossible to upload the file.');
          }
        }
      };

      request.send(formData);
    });
  }

  updateFileUploadProgress(readyState) {
    switch (readyState) {
      case 2:
        this.uploadProgress.next(33);
        break;
      case 3:
        this.uploadProgress.next(66);
        break;
      case 4:
        this.uploadProgress.next(100);
        break;
    }
  }
}
